export const BADGE_TYPES = {
  TRYOUT: 'tryout',
  REGULAR: 'regular'
};

export const DEFAULT_TRYOUT_BADGE = 'draft tryout badge';

export const MAX_TRYOUT_BADGES = 5;

export const INITIAL_JOB_REQUEST_DATA = {};

export const SECTION = {
  CHOOSER: 0,
  INFO: 1,
  LOCATION: 2,
  WHO: 3,
  SCHEDULE: 3,
  PAY: 4,
  BUTTONS: 5,

  // PRS sections
  TIME: 6,
  WONOLOERS: 7,
  REQUIREMENTS: 8,
  DRESS_CODE: 9,
  CLOSED: undefined,
};

export const MAX_BADGES_SELECTED = 5;
export const W2_MAX_BADGES_SELECTED = 4;
export const MAX_SKILLS_SELECTED = 5;

export const SECTION_SLUGS = {
  INFO: 'info',
  LOCATION: 'location',
  SCHEDULE: 'schedule',
  TIME: 'time',
  WONOLOERS: 'wonoloers',
  PAY: 'pay',
  FINAL: 'final',
  REQUIREMENTS: 'requirements',
  DRESS_CODE: 'dressCode',
};

export const DEFAULT_START_HOUR = 9;

export const COLLAPSED_ROW_WIDTHS = [0.3, 0.7];
